import React from 'react';
const testimonials = [{
  initials: 'JH',
  quote: 'I mapped out my whole season in one night. Every single practice now has a clear goal, and I walk on knowing exactly what we are doing.',
  name: 'James H.',
  role: 'Yorkshire, UK'
}, {
  initials: 'MK',
  quote: 'My team improved more in two months than in the entire previous season. The batting progression is exactly what my U14s needed.',
  name: 'Mark K.',
  role: 'Sydney, Australia'
}, {
  initials: 'SP',
  quote: 'I used to spend hours on YouTube hunting for ideas. Now I open Cricket Ready and everything I need for the week is right there.',
  name: 'Sunita P.',
  role: 'Cape Town, SA'
}, {
  initials: 'RT',
  quote: 'The player assessment forms changed everything. My conversations with parents are now professional and data-driven.',
  name: 'Richard T.',
  role: 'Christchurch, NZ'
}, {
  initials: 'EW',
  quote: 'As a first-year coach I was completely overwhelmed. Cricket Ready gave me a full system from day one. My confidence on the ground doubled.',
  name: 'Emma W.',
  role: 'Manchester, UK'
}, {
  initials: 'AB',
  quote: "The bowling progression framework is outstanding. My pacers have better run-ups and my spinners actually know what they're bowling and why.",
  name: 'Arun B.',
  role: 'Mumbai, India'
}];
export function TestimonialsSection() {
  return <section className="w-full bg-white py-16 px-4" data-id="element-233">
      <div className="max-w-5xl mx-auto" data-id="element-234">
        <div className="text-center mb-12" data-id="element-235">
          <h2 className="text-3xl sm:text-4xl font-black text-[#0A0A0A] mb-3 tracking-tight" data-id="element-236">
            What <span className="text-[#d4af37]" data-id="element-237">coaches</span> are saying
          </h2>
          <p className="text-[#5A5A66] text-base font-bold" data-id="element-238">
            ⭐⭐⭐⭐⭐ 4.9/5 · 500+ coaches worldwide
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-239">
          {testimonials.map((t, i) => <div key={i} className="bg-[#FAFAFA] border border-[#E5E5EA] rounded-2xl p-6 flex flex-col shadow-sm" data-id="element-240">
              <div className="flex items-center gap-3 mb-4" data-id="element-241">
                <div className="w-10 h-10 rounded-full bg-[#0A0A0A] flex items-center justify-center text-white font-black text-sm flex-shrink-0" data-id="element-242">
                  {t.initials}
                </div>
                <div className="text-[#d4af37] text-sm" data-id="element-243">⭐⭐⭐⭐⭐</div>
              </div>
              <p className="text-[#0A0A0A] text-sm font-medium italic leading-relaxed mb-6 flex-1" data-id="element-244">
                "{t.quote}"
              </p>
              <div data-id="element-245">
                <p className="text-[#0A0A0A] font-black text-sm" data-id="element-246">{t.name}</p>
                <p className="text-[#5A5A66] text-xs font-semibold mt-0.5" data-id="element-247">
                  {t.role}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}